import { render, staticRenderFns } from "./MainSubnavigation.vue?vue&type=template&id=47e8fd57"
import script from "./MainSubnavigation.vue?vue&type=script&lang=js"
export * from "./MainSubnavigation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports